import { h, FunctionComponent } from "preact";

const DEFAULT_WIDTH = 12;
const DEFAULT_HEIGHT = 8;

interface Props {
    color?: string;
    width?: number;
    class?: string;
}

const IconArrowDown: FunctionComponent<Props> = ({ color, width, class: cssClass }: Props) => {
    const height = width! * DEFAULT_HEIGHT / DEFAULT_WIDTH;
    return (
        <svg class={cssClass} width={width} height={height} viewBox="0 0 12 8">
            <path fill={color} d="M6.003 8c.356 0 .71-.148.982-.442l4.608-4.982c.543-.588.543-1.543-.002-2.132-.546-.593-1.425-.59-1.97-.002L6 4.356 2.383.442C1.84-.145.955-.145.413.444c-.55.593-.548 1.544-.004 2.132l4.605 4.982c.27.293.627.44.984.44L6.002 8z"/>
        </svg>
    );
};

IconArrowDown.defaultProps = {
    color: "var(--teflon)",
    width: DEFAULT_WIDTH
};

export default IconArrowDown;

